export * from './rahmen-anpassung.component';
export * from './rahmen-anpassung.component.module';
